export const isHourlyOrLessFrequent = (cronExpression: string): boolean => {
	const parts = cronExpression.split(' ');

	if (parts.length < 5 || parts.length > 6) {
		throw new Error('Unsupported cron format');
	}

	const minuteField = parts[0];
	const hourField = parts[1];

	// Check if minute field is valid (must be a single number)
	const isSingleMinute = /^\d+$/.test(minuteField);
	if (!isSingleMinute) {
		return false;
	}

	// Check if hour field indicates hourly or less frequent
	// Valid patterns:
	// - "*" (every hour)
	// - "*/1" (every hour)
	// - "*/N" where N > 1 (every N hours)
	// - "0-23" (specific hours)
	const isHourly = hourField === '*' || /^\*\/1$/.test(hourField);
	const isLessFrequent =
		/^\*\/([2-9]|[1-9][0-9]+)$/.test(hourField) ||
		/^([0-9]|1[0-9]|2[0-3])(,([0-9]|1[0-9]|2[0-3]))*$/.test(hourField);

	return isHourly || isLessFrequent;
};
